export default "__VITE_ASSET__DLwRglvt__"